import { notificationManager } from '../Stores/NotificationManager'
import { LoadUnreadCountTask } from './LoadUnreadCountTask'
import { LoadTabUnreadCountsTask } from './LoadTabUnreadCountsTask'
import { LoadNotificationListTask } from './LoadNotificationListTask'

/**
 * Reaction to Centrifugo "UserNotification.Created" publication.
 * Optimistically bumps unread counter, syncs with server, and if the drawer is
 * open — reloads the first page of the list.
 */
export const HandleUserNotificationCreatedTask = (): void => {
    notificationManager.incrementUnreadCount()
    LoadUnreadCountTask()

    // Per-tab badges (Завдання / Від диспетчера) are otherwise only refreshed
    // when the notifications page mounts — so without this a realtime push
    // updates the bottom-nav bell but leaves the tab counters stale until the
    // user opens the page. Keep all three counters in sync on every push.
    LoadTabUnreadCountsTask()

    if (notificationManager.isDrawerOpen) {
        notificationManager.setPagination({ page: 1, total: 0 })
        notificationManager.setNotifications([])
        LoadNotificationListTask({ searchParams: { page: 1 } })
    }
}
